import { IconsProps } from '@/types/shared'
import React from 'react'

const ChevronDownIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-down-icon lucide-chevron-down"
            >
                <path d="m6 9 6 6 6-6" />
            </svg>
        </div>
    )
}

export default ChevronDownIcons
